import React, { memo } from 'react'
import { Box, Text, Grid, Image, Button } from 'grommet'
import styled from 'styled-components'
import ToolData from '../../Data/ToolData'
import MenuIcon from '../MenuIcon'

const ToolsBox = styled(Box)`
  @media (max-width: 900px) {
    display: none;
  }
`

const AllToolsButton = styled(Button)`
  height: 4rem;
  border-radius: 1px;
  border: 0.1rem solid ${props => props.theme.global.colors.inputDarkLight};
  margin-top: 1rem;
  font-weight: 500;
  :hover {
    background-color: ${props => props.theme.global.colors.inputDarkLight};
    color: ${props => props.theme.global.colors.invertTextStrong};
  }
`

const MenuBox = styled(Box)`
  flex-shrink: 0;
`

const ToolLogoImage = styled(Image)`
  max-height: 2.2rem;
  max-width: 2.2rem;
`

const MegaMenuTools = ({ onClose }) => {
  const rearrangeMenu = (menu, columns) => {
    const rows = Math.ceil(menu.length / columns)
    const newMenu = new Array(menu.length)

    menu.forEach((item, index) => {
      const row = index % rows // row index
      const col = Math.floor(index / rows) //column index
      const newIndex = row * columns + col // rearranges based on rows first

      newMenu[newIndex] = item
    })

    return newMenu
  }

  const toolsMenuColumns = 3
  const reorderedToolsMenu = rearrangeMenu(ToolData, toolsMenuColumns)

  return (
    <ToolsBox pad="2rem" width="85rem" background="baseBackground">
      <Grid columns={{ count: toolsMenuColumns, size: 'auto' }}>
        {reorderedToolsMenu.map((item, index) => (
          <Button
            key={index}
            hoverIndicator={{ background: 'hoverBg' }}
            style={{ height: '4.8rem' }}
            onClick={() => {
              window.location.href = item.path
              onClose()
            }}
          >
            <MenuBox direction="row" margin={{ horizontal: '1.2rem' }}>
              <MenuIcon
                size="22px"
                icon={
                  <ToolLogoImage src={item.icon} alt={`${item.name} Icon`} />
                }
              />
              <Text weight="500" style={{ lineHeight: '1.2' }}>
                {item.name}
              </Text>
            </MenuBox>
          </Button>
        ))}
      </Grid>
      <AllToolsButton
        onClick={() => {
          window.location.href = '/tools/'
          onClose()
        }}
        label="All Tools"
      />
    </ToolsBox>
  )
}

export default memo(MegaMenuTools)
